export default (value: number): string => {
  const formattedValue = value
    .toFixed(2)
    .replace(/0+$/, '')
    .replace(/\.$/, '');
  return `${formattedValue}%`;
};
